import { isWithinInterval, parse, isValid } from 'date-fns';

export const dateFromObjectId = (id: String) => {
  if (id) {
    const timestamp = id.toString().substring(0, 8);
    return new Date(parseInt(timestamp, 16) * 1000);
  }
  return '';
};

export const isValidDate = (dateInput) => {
  if (!dateInput) return false;

  let date;

  // If it's already a Date object
  if (dateInput instanceof Date) {
    date = dateInput;
  }
  // Handle string in German DD.MM.YYYY format
  else if (typeof dateInput === 'string' && dateInput.includes('.')) {
    // Try to parse using German format
    date = parse(dateInput, 'dd.MM.yyyy', new Date());

    // If parsing failed, return false
    if (!isValid(date)) {
      return false;
    }
  }
  // ISO format (YYYY-MM-DD) or other formats
  else {
    // Extract year from the string (for ISO and other formats)
    const yearFromDateString = dateInput.match(/(\d{4})/)?.[0];
    if (!yearFromDateString) {
      return false;
    }

    date = new Date(dateInput);

    if (isNaN(date.getTime())) {
      return false;
    }

    const yearFromDate = date.getFullYear().toString();
    // Verify year matches to avoid browser auto-corrections
    return yearFromDateString === yearFromDate;
  }

  return isValid(date);
};

export const isDateInRange = (dateInput, minDate, maxDate) => {
  let date;

  // If it's already a Date object
  if (dateInput instanceof Date) {
    date = dateInput;
  }
  // Handle string in German DD.MM.YYYY format
  else if (typeof dateInput === 'string' && dateInput.includes('.')) {
    date = parse(dateInput, 'dd.MM.yyyy', new Date());
  }
  // ISO format or other formats
  else {
    date = new Date(dateInput);
  }

  // Check if date is valid before using isWithinInterval
  if (!isValid(date) || isNaN(date.getTime())) {
    return false;
  }

  return isWithinInterval(date, { start: minDate, end: maxDate });
};

export const validateDateOfBirth = (dateOfBirth, minDate, maxDate) => {
  return (
    isValidDate(dateOfBirth) && isDateInRange(dateOfBirth, minDate, maxDate)
  );
};

export const padZero = (num: number) =>
  num ? (num?.toString().length === 1 ? `0${num}` : num.toString()) : '00';
